import React from "react";
import Header from "../../components/layout/Header";
import { TrainingValidityPanel } from "./TrainingValidityPanel";

export default function VencimentosPage() {
  return <><Header title="Validade dos treinamentos" /><div className="page-container" data-testid="vencimentos-page"><TrainingValidityPanel /></div></>;
}